/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description DownloadBlob button
 */
import { Button, Flex, Typography, type ButtonProps } from 'antd';
import { Download } from '@icon-park/react';
import useBlobDownload from 'hooks/mutate/useBlobDownload';

interface IProps {
	title?: string;
	hideTitle?: boolean;
	buttonProps?: ButtonProps;
	iconSize?: number;
	titleClassName?: string;
	wrapperClassName?: string;
	blobCategory: S3BlobCategory;
	blobId: string;
	entityType?: EntityTypeEnum;
	contentType?: string;
}

const DownloadBlob: React.FC<IProps> = ({
	title,
	hideTitle,
	buttonProps,
	iconSize = 16,
	titleClassName,
	wrapperClassName,
	blobCategory,
	blobId,
	entityType,
	contentType,
}) => {
	const { mutate: downloadBlob, isPending } = useBlobDownload({ title, contentType });

	return (
		<Flex align='center' gap={8} className={wrapperClassName}>
			{title && !hideTitle && (
				<Typography.Text ellipsis className={titleClassName}>
					{title}
				</Typography.Text>
			)}
			<Button
				{...buttonProps}
				icon={<Download size={iconSize} />}
				disabled={isPending || buttonProps?.disabled}
				onClick={() => downloadBlob({ blobCategory, blobId, entityType })}
			/>
		</Flex>
	);
};

export default DownloadBlob;
